import axios from '@shared/axios-shared';

const getdashboarddata = (type) => {
	return axios.get(`/api/v1/owner/dashboard?type=${type}`);
};

export { getdashboarddata };
